import LegalLayout, { Section, Bullets } from "@/components/legal/LegalLayout";
import { useSeo } from "@/lib/seo";

export default function RefundCancellationPolicy() {
  useSeo({
    title: "Refund & Cancellation Policy – QuickDukaan",
    description: "Order cancellation, refunds and replacement guidelines for QuickDukaan customers.",
    path: "/refund-cancellation-policy",
  });

  return (
    <LegalLayout
      testid="refund-policy-page"
      title="Refund & Cancellation Policy"
      intro="At QuickDukaan, we strive to ensure a smooth shopping experience for customers and sellers."
      crumbs={[{ label: "Refund & Cancellation Policy" }]}
      lastUpdated="21 May 2026"
    >
      <Section number={1} title="Order Cancellation">
        <p>Customers may cancel an order:</p>
        <Bullets items={[
          "Before the seller starts processing the order",
          "Subject to seller approval",
        ]} />
        <p><strong>Once an order is packed or dispatched, cancellation may not be possible.</strong></p>
      </Section>

      <Section number={2} title="Refunds">
        <p>
          Since QuickDukaan currently operates primarily on Cash on Delivery (COD), refund cases may be limited.
        </p>
        <p>Refunds/replacements may be considered in cases such as:</p>
        <Bullets items={[
          "Wrong product delivered",
          "Damaged product",
          "Missing items",
          "Expired items",
        ]} />
      </Section>

      <Section number={3} title="Refund Processing">
        <p>Eligible refunds or replacements will be processed by the respective seller/store owner after review.</p>
      </Section>

      <Section number={4} title="Non-Refundable Situations">
        <p>Refunds may not be applicable for:</p>
        <Bullets items={[
          "Change of mind after delivery",
          "Minor packaging variations",
          "Delay caused by external conditions",
        ]} />
      </Section>

      <Section number={5} title="Contact for Support">
        <p>Email: <a href="mailto:support@quickdukaan.in">support@quickdukaan.in</a></p>
      </Section>
    </LegalLayout>
  );
}
